// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-settings-shell {
  box-sizing: border-box;
  width: min(var(--app-shell-max-width), calc(100vw - (var(--app-shell-gutter) * 2)));
  margin-inline: auto;
  padding-bottom: 48px;
  text-align: left;
}

.system-settings-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
}

.system-settings-kicker {
  margin: 0 0 4px !important;
  color: #2563eb !important;
  font-size: 12px !important;
  font-weight: 700;
  text-transform: uppercase;
}

.system-settings-header h1 {
  margin: 0;
  color: #0f172a;
  font-size: 28px;
  font-weight: 800;
}

.system-settings-header p,
.system-settings-section-heading p {
  margin: 5px 0 0;
  color: #64748b;
  font-size: 13px;
}

.system-settings-panel,
.system-settings-admin {
  max-width: 880px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.system-settings-admin {
  margin-top: 22px;
}

.system-settings-section-heading {
  padding: 20px 24px;
  border-bottom: 1px solid #eef2f7;
}

.system-settings-section-heading h2 {
  margin: 0;
  color: #0f172a;
  font-size: 18px;
  font-weight: 750;
}

.system-setting-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 76px;
  padding: 16px 24px;
  border-bottom: 1px solid #eef2f7;
}

.system-setting-label {
  display: block;
  margin: 0;
  color: #1e293b;
  font-size: 14px;
  font-weight: 700;
}

.system-setting-description {
  margin: 3px 0 0;
  color: #64748b;
  font-size: 12px;
}

.system-setting-segments {
  display: inline-grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 220px;
  padding: 3px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #f8fafc;
}

.system-setting-language {
  width: 300px;
}

.system-setting-segments button {
  min-height: 34px;
  padding: 6px 10px;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.system-setting-segments button.active {
  background: #fff;
  color: #1d4ed8;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
}

.system-setting-select {
  width: 110px;
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  font-size: 13px;
}

.system-setting-switch {
  position: relative;
  width: 42px;
  height: 24px;
  flex: none;
  padding: 0;
  border-radius: 999px;
  background: #cbd5e1;
}

.system-setting-switch.on {
  background: #2563eb;
}

.system-setting-switch span {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.28);
  transition: transform 160ms ease;
}

.system-setting-switch.on span {
  transform: translateX(18px);
}

.system-settings-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  background: #fafbfd;
}

@media (max-width: 600px) {
  .system-settings-header h1 {
    font-size: 24px;
  }

  .system-setting-row {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }

  .system-setting-segments,
  .system-setting-select {
    width: 100%;
  }

  .system-setting-switch {
    align-self: flex-end;
  }

  .system-settings-actions {
    flex-wrap: wrap;
  }

  .system-settings-actions .org-btn {
    flex: 1 1 140px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SettingPage/SettingPage.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mFAAmF;EACnF,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".system-settings-shell {\n  box-sizing: border-box;\n  width: min(var(--app-shell-max-width), calc(100vw - (var(--app-shell-gutter) * 2)));\n  margin-inline: auto;\n  padding-bottom: 48px;\n  text-align: left;\n}\n\n.system-settings-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 18px;\n}\n\n.system-settings-kicker {\n  margin: 0 0 4px !important;\n  color: #2563eb !important;\n  font-size: 12px !important;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.system-settings-header h1 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 28px;\n  font-weight: 800;\n}\n\n.system-settings-header p,\n.system-settings-section-heading p {\n  margin: 5px 0 0;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.system-settings-panel,\n.system-settings-admin {\n  max-width: 880px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.system-settings-admin {\n  margin-top: 22px;\n}\n\n.system-settings-section-heading {\n  padding: 20px 24px;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.system-settings-section-heading h2 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 18px;\n  font-weight: 750;\n}\n\n.system-setting-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  min-height: 76px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #eef2f7;\n}\n\n.system-setting-label {\n  display: block;\n  margin: 0;\n  color: #1e293b;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.system-setting-description {\n  margin: 3px 0 0;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.system-setting-segments {\n  display: inline-grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  width: 220px;\n  padding: 3px;\n  border: 1px solid #dbe3ef;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.system-setting-language {\n  width: 300px;\n}\n\n.system-setting-segments button {\n  min-height: 34px;\n  padding: 6px 10px;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.system-setting-segments button.active {\n  background: #fff;\n  color: #1d4ed8;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);\n}\n\n.system-setting-select {\n  width: 110px;\n  min-height: 38px;\n  padding: 8px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  font-size: 13px;\n}\n\n.system-setting-switch {\n  position: relative;\n  width: 42px;\n  height: 24px;\n  flex: none;\n  padding: 0;\n  border-radius: 999px;\n  background: #cbd5e1;\n}\n\n.system-setting-switch.on {\n  background: #2563eb;\n}\n\n.system-setting-switch span {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.28);\n  transition: transform 160ms ease;\n}\n\n.system-setting-switch.on span {\n  transform: translateX(18px);\n}\n\n.system-settings-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 24px;\n  background: #fafbfd;\n}\n\n@media (max-width: 600px) {\n  .system-settings-header h1 {\n    font-size: 24px;\n  }\n\n  .system-setting-row {\n    align-items: stretch;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .system-setting-segments,\n  .system-setting-select {\n    width: 100%;\n  }\n\n  .system-setting-switch {\n    align-self: flex-end;\n  }\n\n  .system-settings-actions {\n    flex-wrap: wrap;\n  }\n\n  .system-settings-actions .org-btn {\n    flex: 1 1 140px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
